import React from "react";
import "./service.css";
import { Link } from "react-router-dom";
import s_img1 from "../images/noun_oral orthodontics_1945577.png";
import s_img2 from "../images/noun_root canal_1945562.png";
import s_img3 from "../images/noun_Dental Implant_2665773.png";
import s_img4 from "../images/noun_cosmetic dentistry_2051516.png";
import s_img5 from "../images/noun_crown dental_1661446.png";
import s_img6 from "../images/noun_dental veneer_1946265.png";
import s_img7 from "../images/noun_teeth whitening_2531653.png";
import s_img8 from "../images/noun_dental care_2692540.png";
import s_img9 from "../images/noun_childrens dentistry_3292443.png";

function Service() {
  return (
    <section className="services">
      <div className="s-heading">
        <h1>Services</h1>
        <p>We Provide The Best In class Servies For Our Customers</p>
      </div>
      <div className="s-box-container">
        <Link to="/service/braces_orthodontics">
          <div className="s-box">
            <img src={s_img1} alt="1" />
            <h1>ORTHODONTICS</h1>
            <p>
              Orthodontics is a speciality of dentistry that deals with the
              diagnosis, prevention and correction of faulty ...
            </p>
            <Link to="/service/braces_orthodontics" className="s-btn">
              More
            </Link>
          </div>
        </Link>
        <Link to="/service/ROOT_CANEL">
          <div className="s-box">
            <img src={s_img2} alt="1" />
            <h1>ROOT CANAL</h1>
            <p>
              Root canal is a treatment to repair a spoiled tooth instead of
              clearing it. It is different to tooth extraction...
            </p>
            <Link to="/service/ROOT_CANEL" className="s-btn">
              More
            </Link>
          </div>
        </Link>
        <Link to="/service/DENTAL_IMPLANT">
          <div className="s-box">
            <img src={s_img3} alt="1" />
            <h1>Dental Implant</h1>
            <p>
              Dental implants are surgical components helps maintain tooth
              prosthetics that are fabricated to forever durability. .
            </p>
            <Link to="/service/DENTAL_IMPLANT" className="s-btn">
              More
            </Link>
          </div>
        </Link>
      </div>
      <div className="s-box-container">
        <Link to="/service/COSMETIC_DENTISTRY">
          <div className="s-box">
            <img src={s_img4} alt="1" />
            <h1>Cosmetic Dentistry </h1>
            <p>
              Your smile is the first introduction that others have of you, so
              it predict well that you would need it to be brilliant for the...
            </p>
            <Link to="/service/COSMETIC_DENTISTRY" className="s-btn">
              More
            </Link>
          </div>
        </Link>
        <Link to="/service/crowns_bridges">
          <div className="s-box">
            <img src={s_img5} alt="1" />
            <h1>CROWNS & BRIDGES</h1>
            <p>
              Dental crowns and bridges extensions are exclusively fitted tooth
              prosthetics that are utilized to replace or re-establish....
            </p>
            <Link to="/service/crowns_bridges" className="s-btn">
              More
            </Link>
          </div>
        </Link>
        <Link to="/service/venners">
          <div className="s-box">
            <img src={s_img6} alt="1" />
            <h1>VENEERS</h1>
            <p>
              Dental facade – otherwise called overlays are utilized to
              cosmetically improve the presence of at least one or more teeth.
              ....
            </p>
            <Link to="/service/venners" className="s-btn">
              More
            </Link>
          </div>
        </Link>
      </div>
      <div className="s-box-container">
        <Link to="/service/TEETH_WHITENING">
          <div className="s-box">
            <img src={s_img7} alt="1" />
            <h1> TEETH WHITENING</h1>
            <p>
              Teeth brightening methods are utilized to light up the presence of
              a patient's grin – at times ...
            </p>
            <Link to="/service/TEETH_WHITENING" className="s-btn">
              More
            </Link>
          </div>
        </Link>
        <Link to="/service/ORAL_SURGERY">
          <div className="s-box">
            <img src={s_img8} alt="1" />
            <h1>ORAL SURGERY</h1>
            <p>
              {" "}
              Oral medicinal method is consistently performed in a dental office
              setting under anaesthesia...
            </p>
            <Link to="/service/ORAL_SURGERY" className="s-btn">
              More
            </Link>
          </div>
        </Link>
        <Link to="/service/CHILD_DENTISTRY">
          <div className="s-box">
            <img src={s_img9} alt="1" />
            <h1>CHILD DENTISTRY & PREVENTIVE CARE</h1>
            <p>
              Child dentistry is a treatment of oral medical issues with
              children right from birth to adolescence...
            </p>
            <Link to="/service/CHILD_DENTISTRY" className="s-btn">
              More
            </Link>
          </div>
        </Link>
      </div>
    </section>
  );
}

export default Service;
